import { render, staticRenderFns } from "./OrderSummaryPanel.vue?vue&type=template&id=7d9bff8b&scoped=true&"
import script from "./OrderSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryPanel.vue?vue&type=style&index=0&id=7d9bff8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9bff8b",
  null
  
)

export default component.exports